import React, { useState } from "react";
import TrainLoader from '../General/TrainLoader';
// Optional: if you create a CSS module, uncomment the next line
// import styles from "./personnelDatabase.module.css";

const PersonnelDatabase = () => {
  const [loaded, setLoaded] = useState(false);

  const spinnerContainerStyle = {
    position: 'fixed', 
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
  };

  return (
    <div style={{ width: "100%", height: "100%", minHeight: "100vh" }}>
      {!loaded && (
        <div style={spinnerContainerStyle}>
          <TrainLoader />
        </div>
      )}

      <iframe
        className="airtable-embed"
        src="https://airtable.com/embed/app8dkma3SEr8BBWS/shrCK8IY1QdRGDJkU"
        frameBorder="0"
        width="100%"
        height="100%"
        style={{ background: "transparent", border: "1px solid #ccc" }}
        title="Personnel Database"
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default PersonnelDatabase;